<div normal>
        <modal-default-mmaxapp>
                <div class="tarjetaconfirmar">
                        <div class="titulo">
                                Necesita completar el pago.
                        </div>
                        <div class="leyendaconfirmar">
                                No puede continuar hasta que el pago este completo.
                                <br>
                                <br>
                                Si tiene algun problema comuniquese con el proveedor. Gracias!
                        </div>
                        <div class="botones" style="display: flex; gap: 1rem; justify-content: center; flex-direction: column; align-items: center;">
                                <button class="buttonpc whibutton" (click)="aceptar()">Elegir Medio de Pago</button>
                                <button class="buttonpc whibutton" style="background-color: #6c757d; color: white; border: none;" (click)="volverAlCarrito()">Volver al Carrito</button>
                                <button class="buttonpc whibutton"
                                        style="background-color: var(--accent-color); color: white; border: none;"
                                        (click)="cancelarCompra()">Cancelar Todo y Salir</button>
                        </div>
                </div>
        </modal-default-mmaxapp>
</div>